export default "__VITE_ASSET__5Z6B62Kb__"